import LegalPageShell from '../components/LegalPageShell';

const metaDescription =
  'Privacy policy for Dragon Metalworks: how we collect, use, and protect personal data when you use our website and contact us.';

export default function PrivacyPolicyPage() {
  return (
    <LegalPageShell title="Privacy Policy" description={metaDescription}>
      <header className="legal-page-header">
        <p className="legal-page-kicker">Legal</p>
        <h1>Privacy Policy</h1>
        <p className="legal-page-updated">Last updated: April 2026</p>
      </header>

      <section className="legal-section" aria-labelledby="legal-intro">
        <h2 id="legal-intro">Introduction</h2>
        <p>
          Dragon Metalworks (&quot;we&quot;, &quot;us&quot;, or &quot;our&quot;) respects your privacy. This policy
          explains how we handle personal information when you visit our website or get in touch about steel
          fabrication, supply, and related services in London and the wider UK.
        </p>
      </section>

      <section className="legal-section" aria-labelledby="legal-collect">
        <h2 id="legal-collect">Information we collect</h2>
        <p>We may collect the following types of information:</p>
        <ul>
          <li>
            <strong>Contact details</strong> you provide voluntarily, such as name, email address, telephone number,
            and company name.
          </li>
          <li>
            <strong>Project information</strong> included in your messages, such as site location, scope of work, or
            drawings references, where relevant to your enquiry.
          </li>
          <li>
            <strong>Technical data</strong> such as IP address, browser type, device type, and general location (e.g.
            country or region) collected automatically when you use our website.
          </li>
        </ul>
      </section>

      <section className="legal-section" aria-labelledby="legal-use">
        <h2 id="legal-use">How we use information</h2>
        <p>We use personal information to:</p>
        <ul>
          <li>Respond to enquiries, quotations, and service requests.</li>
          <li>Communicate with you about projects, appointments, or contractual matters.</li>
          <li>Improve our website, services, and customer experience.</li>
          <li>Meet legal, regulatory, or insurance obligations where applicable.</li>
        </ul>
        <p>We do not sell your personal data.</p>
      </section>

      <section className="legal-section" aria-labelledby="legal-forms">
        <h2 id="legal-forms">Contact form submissions</h2>
        <p>
          When you submit our contact or quote form, your details are processed so we can reply to you. Information is
          handled securely and only shared with members of our team or trusted partners (for example, structural
          engineers or couriers) when necessary to progress your enquiry.
        </p>
      </section>

      <section className="legal-section" aria-labelledby="legal-cookies">
        <h2 id="legal-cookies">Cookies and analytics</h2>
        <p>
          Our website may use cookies or similar technologies that are strictly necessary for the site to function, or
          to understand aggregate usage (for example, which pages are visited most often). Where non-essential cookies
          are used, we will seek your consent where required by law.
        </p>
      </section>

      <section className="legal-section" aria-labelledby="legal-retention">
        <h2 id="legal-retention">Data retention</h2>
        <p>
          We retain personal data only for as long as needed to fulfil the purposes described in this policy, including
          legitimate business, accounting, and legal requirements. Enquiry records are typically kept for a limited
          period unless a longer retention period applies to an ongoing contract or dispute.
        </p>
      </section>

      <section className="legal-section" aria-labelledby="legal-rights">
        <h2 id="legal-rights">Your rights</h2>
        <p>
          Depending on applicable law (including UK GDPR where relevant), you may have the right to access, correct,
          delete, or restrict processing of your personal data, and to object to certain processing. You may also have
          the right to lodge a complaint with a supervisory authority.
        </p>
        <p>To exercise your rights, please contact us using the details below.</p>
      </section>

      <section className="legal-section" aria-labelledby="legal-contact">
        <h2 id="legal-contact">Contact details</h2>
        <p>
          For privacy-related questions or requests, please contact Dragon Metalworks using the email or telephone
          details shown in the footer of this website, or write to our registered business address.
        </p>
      </section>
    </LegalPageShell>
  );
}
